import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { GlowModal, GlowTag, GlowTextBody } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { RichText } from '../../i18n';
import styles from './loyalty.module.css';

type MySephoraPushLoyaltyContentProps = {
    loyaltyPointsLabel: string;
};

export const MySephoraPushLoyaltyContent: Component<MySephoraPushLoyaltyContentProps> = ({ loyaltyPointsLabel }) => {
    const t = useTranslations('Discover.Pdp.loyalty');
    const commonT = useTranslations('Modal.pushLoyalty.mySephora.label');

    return (
        <GlowModal.Content contentClassName={'!gap-2'}>
            <div className={'flex flex-col gap-1'}>
                <div className={'flex flex-col gap-0.5'}>
                    <GlowTextBody text={commonT('discoverCommunity')} fontWeight={'bold'} TagName={'h3'} />
                    <GlowTextBody text={commonT('programAdvantages')} />
                </div>
                <div className={clsx('flex flex-row gap-x-0.5', 'rounded-0.5 p-1.5', styles.customGradientFid)}>
                    <GlowTag label={loyaltyPointsLabel} color={'primaryGreen'} size={'large'} />
                    <GlowTextBody className={'flex flex-col justify-center'} text={t('label.fidText')} />
                </div>
            </div>
            <div className={'flex flex-col gap-1'}>
                <GlowTextBody text={commonT('howItWorks')} fontWeight={'bold'} TagName={'h3'} />
                <RichText messageKey={'Modal.pushLoyalty.mySephora.label.howItWorksDescription'} fontSize={'body'} />
                <GlowTextBody text={commonT('upToYou')} />
            </div>
        </GlowModal.Content>
    );
};
